// extracted by mini-css-extract-plugin
export default {"tabletImg":"tI","desktopImg":"uI","mobileImg":"vI","backgroundImage":"wI","content":"xI","rtbLeft":"yI","rtbRight":"zI","imageContainer":"AI","rtbBox":"BI","line":"CI","rtbLeftMobile":"EI","rtbDesktop":"FI"};
    if(module.hot) {
      // 1713361651677
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  